import React, { useState, useEffect } from "react";
import { Ruler, Flame, Gem, Zap, Award, Calendar } from "lucide-react";

import { CEMFLOOR_LOGO } from "./Navbar";
import { LazyImg } from "./LazyImg";

const benefits = [
  { title: "Perfectly Flat Floors", Icon: Ruler },
  { title: "Underfloor Heating", Icon: Flame },
  { title: "Superior Strength", Icon: Gem },
  { title: "Fast Installation", Icon: Zap },
  { title: "10-Year Cemfloor Guarantee", Icon: Award, cemfloorLogo: true },
  { title: "7 Years' Experience", Icon: Calendar },
];

export const ScreedAdvantage: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % benefits.length);
    }, 2500);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="bg-[#080810] text-stone-100">
      <section className="py-20 md:py-28 bg-white text-stone-900 rounded-tl-[80px] md:rounded-tl-[200px] lg:rounded-tl-[260px] relative z-10">
        <div className="container mx-auto px-4 max-w-6xl">
          {/* Header */}
          <header className="text-center mb-12 md:mb-16">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight text-stone-900 mb-4">
              Why Choose{" "}
              <span className="gold-gradient-text">Exeter Flow Screed?</span>
            </h2>
          </header>

          {/* Grid Layout - internal dividers only, auto-rotating gold highlight */}
          <div className="grid grid-cols-2 lg:grid-cols-3">
            {benefits.map((item, index) => {
              const isActive = index === activeIndex;
              const borderClasses = [
                "border-stone-200",
                index < 4 ? "max-lg:border-b" : "",
                index % 2 === 0 ? "max-lg:border-r" : "",
                index < 3 ? "lg:border-b" : "",
                index % 3 !== 2 ? "lg:border-r" : "",
              ].join(" ");

              const { Icon } = item;

              return (
                <div
                  key={index}
                  className={`relative flex flex-col justify-center items-center p-6 md:p-8 text-center min-h-[160px] ${borderClasses}`}
                >
                  <Icon
                    className={`w-8 h-8 mb-3 transition-colors duration-500 ${isActive ? "text-[#C9A84C]" : "text-stone-400"}`}
                  />
                  <span
                    className={`text-base md:text-xl font-medium transition-colors duration-500 ${isActive ? "text-[#C9A84C]" : "text-stone-800"}`}
                  >
                    {item.title}
                  </span>
                  {item.cemfloorLogo && (
                    <LazyImg
                      src={CEMFLOOR_LOGO}
                      alt="Cemfloor Certified Logo"
                      width={104}
                      height={42}
                      loading="lazy"
                      decoding="async"
                      className="h-5 w-auto object-contain mt-2 opacity-70"
                    />
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};
